import * as React from 'react'
import { Theme } from '@mui/material/styles'
import { FC } from 'react'

import Card from '@mui/material/Card'

const styles = {
  root: {
    border: 'solid 1px #d1d1d6',
    boxShadow: '0 2px 2px 0 #dddddd',
    marginBottom: (theme: Theme) => theme.spacing(3),
  },
}

interface Props {
  children: React.ReactNode
}

export const EntityCardWrapper: FC<Props> = (props) => {
  const { children } = props

  return (
    <Card raised={true} variant="elevation" sx={styles.root}>
      {children}
    </Card>
  )
}

EntityCardWrapper.displayName = 'EntityCardWrapper'
